/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortItem } from './SortItem';
import {
    SortItemFromJSON,
    SortItemFromJSONTyped,
    SortItemToJSON,
    SortItemToJSONTyped,
} from './SortItem';

/**
 * 
 * @export
 * @interface WebsitImageConfigSortReqVo
 */
export interface WebsitImageConfigSortReqVo {
    /**
     * 排序列表
     * @type {Array<SortItem>}
     * @memberof WebsitImageConfigSortReqVo
     */
    sortList: Array<SortItem>;
}

/**
 * Check if a given object implements the WebsitImageConfigSortReqVo interface.
 */
export function instanceOfWebsitImageConfigSortReqVo(value: object): value is WebsitImageConfigSortReqVo {
    if (!('sortList' in value) || value['sortList'] === undefined) return false;
    return true;
}

export function WebsitImageConfigSortReqVoFromJSON(json: any): WebsitImageConfigSortReqVo {
    return WebsitImageConfigSortReqVoFromJSONTyped(json, false);
}

export function WebsitImageConfigSortReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsitImageConfigSortReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'sortList': ((json['sortList'] as Array<any>).map(SortItemFromJSON)),
    };
}

export function WebsitImageConfigSortReqVoToJSON(json: any): WebsitImageConfigSortReqVo {
    return WebsitImageConfigSortReqVoToJSONTyped(json, false);
}

export function WebsitImageConfigSortReqVoToJSONTyped(value?: WebsitImageConfigSortReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortList': ((value['sortList'] as Array<any>).map(SortItemToJSON)),
    };
}

